import { render, staticRenderFns } from "./TabsPeopleRanking.vue?vue&type=template&id=26c40218&scoped=true"
import script from "./TabsPeopleRanking.vue?vue&type=script&lang=js"
export * from "./TabsPeopleRanking.vue?vue&type=script&lang=js"
import style0 from "./TabsPeopleRanking.vue?vue&type=style&index=0&id=26c40218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c40218",
  null
  
)

export default component.exports